import { Box } from '@dropbox/dig-foundations';
import React from 'react';
import { PageFooter } from 'signer-app/parts/page-footer';
import { PageHeader } from 'signer-app/parts/page-header';

export function WebsiteLayout({
  isEmbedded,
  children,
}: React.PropsWithChildren<{
  isEmbedded: boolean;
}>): JSX.Element {
  return (
    <Box height="100%" display="flex" flexDirection="column">
      {!isEmbedded && <PageHeader />}
      <Box backgroundColor="Background Subtle" flexGrow={1}>
        {children}
      </Box>
      {!isEmbedded && <PageFooter />}
    </Box>
  );
}
